import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PaymentState {
  stripePublicKey: string | undefined
}

const initialState: PaymentState = {
  stripePublicKey: undefined
};

const paymentSlice = createSlice({
  name: 'session',
  initialState: {
    ...initialState,
  },
  reducers: {
    setPublicKey(state, action: PayloadAction<string>) {
      state.stripePublicKey = action.payload;
    },
  },
})

export const { setPublicKey } = paymentSlice.actions;

export default paymentSlice.reducer;
